import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// ------------------------------------------------------RED-------------------------------------------------------------

export const getRed = async() => {
    const respuesta = await PrivateInterceptor(`IT/DireccionesIP`, 'GET')
    return respuesta;
}

export const guardarRed = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/AgregarDireccionIP", "POST",{datos});
    return respuesta;
};

export const editarRed = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/EditarDireccionIP", "POST",{datos});
    return respuesta;
};

export const eliminarRed = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/Eliminar2DireccionIP", "POST",{datos});
    return respuesta;
};

// ------------------------------------------------------Video-------------------------------------------------------------

export const getRedVideo = async() => {
    const respuesta = await PrivateInterceptor(`IT/DireccionesIP/Video`, 'GET')
    return respuesta;
}

export const guardarRedVideo = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/AgregarDireccionIPVideo", "POST",{datos});
    return respuesta;
};

export const editarRedVideo = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/EditarDireccionIPVideo", "POST",{datos});
    return respuesta;
};

export const eliminarIPVideo = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/Eliminar2DireccionIPVideo", "POST",{datos});
    return respuesta;
};


// ------------------------------------------------------Teleofnia-------------------------------------------------------------

export const getRedTelefonia = async() => {
    const respuesta = await PrivateInterceptor(`IT/DireccionesIP/telefonia`, 'GET')
    return respuesta;
}

export const guardarRedTelefonia = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/AgregarDireccionIPTelefonia", "POST",{datos});
    return respuesta;
};

export const editarRedTelefonia = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/EditarDireccionIPTelefonia", "POST",{datos});
    return respuesta;
};

export const eliminarIPTelefonia = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/DireccionesIP/Eliminar2DireccionIPTelefonia", "POST",{datos});
    return respuesta;
};


// -----------------------------------------------------ROUTERS----------------------------------------------------------

export const guardarRuta = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/Rutas/AgregarRuta", "POST",{datos});
    return respuesta;
};
  
  export const editarRuta = async (datos) => {
    const respuesta = await PrivateInterceptor("IT/Rutas/EditarRuta", "POST",{datos});
    return respuesta;
};






// -----------------------------------------------------GENERALES----------------------------------------------------------

export const getTipoRed = async() => {
    const respuesta = await PrivateInterceptor(`IT/DireccionesIP/TipoRedesDatos`, 'GET')
    return respuesta;
}

export const getClaseRed = async() => {
    const respuesta = await PrivateInterceptor(`IT/DireccionesIP/ClaseRed`, 'GET')
    return respuesta;
}

export const getPersonal = async() => {
    const respuesta = await PrivateInterceptor(`Payrolls/personal`, 'GET')
    return respuesta;
}